import React, { useRef } from 'react';
import ReactDOM from 'react-dom';
import { CSSTransition } from 'react-transition-group';
import Backdrop from './Backdrop';
import './AreaModal.css';

const ModalOverlay = props => {
  const { areas } = props;

  const content = (
    <div ref={props.nodeRef} className="area-modal rounded rtl  ">
      <header className="area-modal__header rounded text-dark">
        <h5 className="font-weight-bold text-left d-flex justify-content-between">
          <span>انتخاب منطقه</span>
          <span>
            <button 
              type="button" 
              className="close" 
              aria-label="Close" 
              onClick={() => props.onCancel()}
            >
              <span aria-hidden="true">&times;</span>
          </button>
          </span>
        </h5>
        <div>
          <div className="search-input-layer">
            <span className="">
              <i className="fa fa-search text-muted"></i>
            </span>
            <input
              type="text"
              placeholder="جستجو کنید"
              className="col inline-block form-control"
            // onChange={onSearchHandler}
            // value={searchInput}
            />
          </div>
        </div>
      </header>
      <div>
        <div className="area-modal__content">
          <div>
            <table className="table table-hover" >
              <tbody >
                {
                  areas.map(area => 
                    <tr key={area._id} style={{cursor:'pointer'}}
                      onClick={() => {
                        props.onCancel();
                        props.setArea(area)
                      }} 
                    >
                      <th scope="row">
                        <span className="text-dark font-weight-normal">{area.title}</span>
                      </th>
                      <td className="text-right">
                        <i className="fa fa-chevron-left text-muted font-weight-normal"></i>
                      </td>
                    </tr>
                  )
                }
              </tbody>
            </table>
          </div>
        </div>
        <footer className="area-modal__footer">
        </footer>
      </div>
    </div>
  );
  return ReactDOM.createPortal(content, document.getElementById('area-modal-hook'));
};

const AreaModal = props => {
  const nodeRef = useRef(null);
  return (
    <React.Fragment>
      {props.show && <Backdrop onClick={props.onCancel} bgLighter />}
      <CSSTransition
        nodeRef={nodeRef}
        in={props.show}
        mountOnEnter
        unmountOnExit
        timeout={500}
        classNames="area-modal"
      >
        <ModalOverlay nodeRef={nodeRef} {...props} />
      </CSSTransition>
    </React.Fragment>
  );
};

export default AreaModal;
